import React, { Component } from 'react'
import { connect } from 'react-redux'

import '../../../../styles/css/components/structure/footer/bk-flow-footer-basic.css'

class BkFlowFooterBasic extends Component {
	render() {
		const {
			availabilityLoading,
			configData,
		} = this.props

		return configData && !availabilityLoading && (
			<div className="bk-flow-footer basic">
				{/* <!-- OneTrust Cookies List start --> */}
				<div id="ot-sdk-cookie-policy"></div>
				{/* <!-- OneTrust Cookies List end --> */}
				{/* <!-- OneTrust Cookies Settings button start --> */}
				<button id="ot-sdk-btn" className="ot-sdk-show-settings">Cookie Settings</button>
				{/* <!-- OneTrust Cookies Settings button end --> */}
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		availabilityLoading: state.availabilityData.loading,
		configData: state.configData.configuration,
	}
}


export default connect(mapStateToProps, null)(BkFlowFooterBasic)


// WEBPACK FOOTER //
// ./src/components/structure/footer/layouts/BkFlowFooterBasic.js